import { ChartData, ChartOptions } from 'chart.js';

export class ChartInfo {
  data: ChartData;
  options: ChartOptions;
  type: string;

  constructor(init?: Partial<ChartInfo>) {
    Object.assign(this, init);
  }
}